import { giphyBlack } from '@giphy/colors'
import { fonts } from 'types'
import DropdownButton from 'ui/src/components/controls/dropdown-button'
import SelectList from 'ui/src/components/controls/select-list'
import { fontScale, fontTitle, fontFamily as getFontFamily } from 'utils'
import { useFontInfo } from '../../../hooks/use-font-info'

type Props = {
    buttonColor?: string
    className?: string
    fontFamily: string
    onChange?: (fontFamily: string) => void
}

const FONTS = fonts.map((font) => (
    <span key={fontTitle(font)} style={{ fontFamily: getFontFamily(font), fontSize: `${fontScale(font)}em` }}>
        {fontTitle(font)}
    </span>
))

const UGECaptionsEditorFont = ({ buttonColor = giphyBlack, className, fontFamily, onChange }: Props) => {
    const { fontScale, index, label } = useFontInfo(fontFamily)
    const labelStyle = { fontFamily, fontSize: `${fontScale}em` }

    function onIndexChange(index: number) {
        const font = fonts[index]

        onChange?.(getFontFamily(font))
    }

    return (
        <DropdownButton
            iconButtonOptions={{ color: buttonColor }}
            className={className}
            label={<span style={labelStyle}>{label}</span>}
        >
            <SelectList defaultIndex={index} options={FONTS} onChange={onIndexChange} />
        </DropdownButton>
    )
}

export default UGECaptionsEditorFont
